import React from 'react';
import CustomGrid from '../../../../common/components/CustomGrid';
import './LeaveCalendar.css';
import CustomCard from '../../../../common/components/CustomCard';
import LeaveCalendarDataController from '../../../../common/components/AllCalendars/LeaveCalendar/LeaveCalendarDataController';

const LeaveCalendarPresenter = () => {
  return (
    <CustomGrid>
      <CustomCard
        cardHeight="350px"
        cardWidth="auto"
        cardSize={{ card_title: '' }}
      >
        <LeaveCalendarDataController />
      </CustomCard>
    </CustomGrid>
  );
};

export default LeaveCalendarPresenter;
